"use strict";

var _regeneratorRuntime = require("/home/travis/build/deepintr/deepintr.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/home/travis/build/deepintr/deepintr.github.io/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/deepintr/deepintr.github.io/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var tslib_1 = require("tslib");

var Container_1 = require("./Container");

var Utils_1 = require("../Utils");

var tsParticlesDom = [];

var Loader = /*#__PURE__*/function () {
  function Loader() {
    _classCallCheck(this, Loader);
  }

  _createClass(Loader, null, [{
    key: "dom",
    value: function dom() {
      return tsParticlesDom;
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      var dom = Loader.dom();
      var item = dom[index];

      if (item && !item.destroyed) {
        return item;
      }

      dom.splice(index, 1);
    }
  }, {
    key: "loadFromArray",
    value: function loadFromArray(tagId, options, index) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Loader.load(tagId, Utils_1.Utils.itemFromArray(options, index)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "setFromArray",
    value: function setFromArray(id, domContainer, options, index) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", Loader.set(id, domContainer, Utils_1.Utils.itemFromArray(options, index)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "load",
    value: function load(tagId, options) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var domContainer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                domContainer = document.getElementById(tagId);

                if (domContainer) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                return _context3.abrupt("return", Loader.set(tagId, domContainer, options));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "set",
    value: function set(id, domContainer, options) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var dom, oldIndex, old, canvasEl, generatedCanvas, existingCanvases, newItem;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dom = Loader.dom();
                oldIndex = dom.findIndex(function (v) {
                  return v.id === id;
                });

                if (oldIndex >= 0) {
                  old = Loader.domItem(oldIndex);

                  if (old && !old.destroyed) {
                    old.destroy();
                    dom.splice(oldIndex, 1);
                  }
                }

                if (domContainer.tagName.toLowerCase() === "canvas") {
                  canvasEl = domContainer;
                  generatedCanvas = false;
                } else {
                  existingCanvases = domContainer.getElementsByTagName("canvas");

                  if (existingCanvases.length) {
                    canvasEl = existingCanvases[0];

                    if (!canvasEl.className) {
                      canvasEl.className = Utils_1.Constants.canvasClass;
                    }

                    generatedCanvas = false;
                  } else {
                    generatedCanvas = true;
                    canvasEl = document.createElement("canvas");
                    canvasEl.className = Utils_1.Constants.canvasClass;
                    canvasEl.style.width = "100%";
                    canvasEl.style.height = "100%";
                    domContainer.appendChild(canvasEl);
                  }
                }

                newItem = new Container_1.Container(id, options);

                if (oldIndex >= 0) {
                  dom.splice(oldIndex, 0, newItem);
                } else {
                  dom.push(newItem);
                }

                newItem.canvas.loadCanvas(canvasEl, generatedCanvas);
                _context4.next = 9;
                return newItem.start();

              case 9:
                return _context4.abrupt("return", newItem);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "loadJSON",
    value: function loadJSON(tagId, jsonUrl) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response, options;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetch(jsonUrl);

              case 2:
                response = _context5.sent;

                if (!response.ok) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 6;
                return response.json();

              case 6:
                options = _context5.sent;

                if (!(options instanceof Array)) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", Loader.loadFromArray(tagId, options));

              case 11:
                return _context5.abrupt("return", Loader.load(tagId, options));

              case 12:
                _context5.next = 15;
                break;

              case 14:
                Loader.fetchError(response.status);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  }, {
    key: "setJSON",
    value: function setJSON(id, domContainer, jsonUrl) {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var response, options;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetch(jsonUrl);

              case 2:
                response = _context6.sent;

                if (!response.ok) {
                  _context6.next = 14;
                  break;
                }

                _context6.next = 6;
                return response.json();

              case 6:
                options = _context6.sent;

                if (!(options instanceof Array)) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", Loader.setFromArray(id, domContainer, options));

              case 11:
                return _context6.abrupt("return", Loader.set(id, domContainer, options));

              case 12:
                _context6.next = 15;
                break;

              case 14:
                Loader.fetchError(response.status);

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      var dom = Loader.dom();

      if (dom.length === 0) {
        throw new Error("Can only set click handlers after calling tsParticles.load() or tsParticles.loadJSON()");
      }

      var _iterator = _createForOfIteratorHelper(dom),
          _step;

      try {
        var _loop = function _loop() {
          var domItem = _step.value;
          var el = domItem.interactivity.element;

          if (!el) {
            return "continue";
          }

          var clickOrTouchHandler = function clickOrTouchHandler(e, pos) {
            if (domItem.destroyed) {
              return;
            }

            var pxRatio = domItem.retina.pixelRatio;
            var particles = domItem.particles.quadTree.query(new Utils_1.Circle(pos.x * pxRatio, pos.y * pxRatio, domItem.retina.sizeValue));
            callback(e, particles);
          };

          var clickHandler = function clickHandler(e) {
            if (domItem.destroyed) {
              return;
            }

            var mouseEvent = e;
            var pos = {
              x: mouseEvent.offsetX || mouseEvent.clientX,
              y: mouseEvent.offsetY || mouseEvent.clientY
            };
            clickOrTouchHandler(e, pos);
          };

          var touchStartHandler = function touchStartHandler() {
            if (domItem.destroyed) {
              return;
            }

            touched = true;
            touchMoved = false;
          };

          var touchMoveHandler = function touchMoveHandler() {
            if (domItem.destroyed) {
              return;
            }

            touchMoved = true;
          };

          var touchEndHandler = function touchEndHandler(e) {
            var _a, _b, _c;

            if (domItem.destroyed) {
              return;
            }

            if (touched && !touchMoved) {
              var touchEvent = e;
              var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];
              var canvasRect = (_a = domItem.canvas.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
              var pos = {
                x: lastTouch.clientX - ((_b = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) !== null && _b !== void 0 ? _b : 0),
                y: lastTouch.clientY - ((_c = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) !== null && _c !== void 0 ? _c : 0)
              };
              clickOrTouchHandler(e, pos);
            }

            touched = false;
            touchMoved = false;
          };

          var touchCancelHandler = function touchCancelHandler() {
            if (domItem.destroyed) {
              return;
            }

            touched = false;
            touchMoved = false;
          };

          var touched = false;
          var touchMoved = false;
          el.addEventListener("click", clickHandler);
          el.addEventListener("touchstart", touchStartHandler);
          el.addEventListener("touchmove", touchMoveHandler);
          el.addEventListener("touchend", touchEndHandler);
          el.addEventListener("touchcancel", touchCancelHandler);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "fetchError",
    value: function fetchError(statusCode) {
      console.error("Error tsParticles - fetch status: ".concat(statusCode));
      console.error("Error tsParticles - File config not found");
    }
  }]);

  return Loader;
}();

exports.Loader = Loader;